import React, {Component} from 'react';
import AlertMessage from '../AlertMessage';

class PatientDetails extends Component {

    render() {
        const patient = this.props.patient;
        if (!patient) {
            return (null);
		}

		let address = patient.addresses ? patient.addresses.find(addr => addr.type === 'shipping') : null;
		const { address1, address2, city, state, zipCode, voicePhone } = (address || {});
		let displayAddress = address1 || address2 || city || state || zipCode;
    	
        return (
            <>
                <div className="separator-2"></div>
                <div className="row">
                    <div className="col-sm-6 col-md-4">
                        Patient Name: <strong>
                            {patient.nameFirst}&nbsp;
                            {patient.nameMiddle}&nbsp;
                            {patient.nameLast}</strong>
                        <br />
                        <span style={{"display": "inline-block", "verticalAlign": "top"}}>Address:&nbsp;</span>
						{displayAddress && (
							<span style={{ "display": "inline-block" }}>
								<strong>{address1}</strong>
								<br />
								{address2 &&
									<strong>{address2}<br /></strong>
								}
								<strong> {city}, {state} {zipCode}</strong>
							</span>
						)}
                    </div>
                    <div className="col-sm-6 col-md-4">
                        DOB: <strong> {patient.dateOfBirth}</strong>
                        <br />
                        Sex: <strong> {patient.gender}</strong>
                    </div>
                    <div className="col-sm-6 col-md-4">
						Phone: {voicePhone && <strong>{voicePhone.length === 10 ? ("(" + voicePhone.substring(0, 3) + ") " + voicePhone.substring(3, 6) + "-" + voicePhone.substring(6)) : voicePhone}</strong>}
                        <br />
                        Email Address: <strong>{patient.email}</strong>
                    </div>
				</div>
				<ResponsiblePartyName patient={patient} />
                {this.props.missingPatientInfo && this.props.userInfo.type === "myGDX" && (
                	<AlertMessage type="info">
					<strong>Incomplete. The patient will need to provide this information.</strong>
				</AlertMessage>
				)}
            </>
        );
    }

}

const ResponsiblePartyName = ({patient}) => {
	const rpFirstName = patient?.responsibleNameFirst;
	const rpLastName = patient?.responsibleNameLast;
	const rpMiddleName = patient?.responsibleNameMiddle;

	if (!rpFirstName) {
		return null;
	}

	let fullName = rpFirstName + ' '
		+ (rpMiddleName ? rpMiddleName + '. ' : '')
		+ rpLastName ?? '';

	return (
		<div className="row">
			<div className="col-xs-12">
				Responsible Party: <strong>{fullName}</strong>
			</div>
		</div>
	);
}

export default PatientDetails;
